import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import {
  ActivityLogRequestModel,
  ActivityLogResultModel,
  ActivityLogChangesRequestModel,
  ActivityLogChangesResultModel,
  ActivityLogViewRequestModel,
} from "../interfaces/entities/activity-log";

@Injectable({
  providedIn: "root",
})
export class ActivityLogService {
  constructor(private apiService: ApiBaseService) {}

  async getActivityLog(
    request: ActivityLogRequestModel
  ): Promise<ActivityLogResultModel> {
    return this.apiService.httpRequest(
      "ActivityLogService/GetActivityLog",
      request,
      true,
      true
    );
  }

  async getActivityLogChanges(
    request: ActivityLogChangesRequestModel
  ): Promise<ActivityLogChangesResultModel> {
    return this.apiService.httpRequest(
      "ActivityLogService/GetActivityLogChanges",
      request,
      true,
      true
    );
  }

  /**
   * Records that the user actually looked at something. Fire-and-forget on purpose: audit
   * logging must never show a loader, block the page, or surface an error to the user.
   */
  logView(request: ActivityLogViewRequestModel): void {
    this.apiService
      .httpRequest("ActivityLogService/LogView", request, true, false)
      .catch(() => {});
  }
}
